import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_ventas ?(
      <div className="container">
        <br />
        <br />
        <Row >
        {/* <Col md={4} align="center">
              {user.menu_clientes ? (
                <Button
                  href="/Zonas"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-map-marked-alt fa-7x"></i>
                  <br />
                  <br />
                  Zonas
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-map-marked-alt fa-7x"></i>
                  <br />
                  <br />
                  Zonas
                </Button>
              )}
            </Col>
        <Col md={4} align="center">
              {user.menu_clientes ? (
                <Button
                  href="/Clientes"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Clientes
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Clientes
                </Button>
              )}
            </Col> */}
        <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPedidos" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Pedidos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Pedidos
        </Button> }
          </Col>

        {/* <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPedidosDiseno" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Pedidos Diseno
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Pedidos Diseno
        </Button> }
          </Col> */}
          <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/ListadoPendienteSurtir" className="botonesMenu" color="success">
              <i class="fas fa-truck-moving fa-7x"></i>
              <br />
              <br />
              Entregar
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-truck-moving fa-7x"></i>
          <br />
          <br />
          Entregar
        </Button> }
          </Col>
          {/* </Row>
          <br />
          <Row> */}

{/* <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPendientePedidoCliente" className="botonesMenu" color="success">
              <i class="fas fa-clipboard-list fa-7x"></i>
              <br />
              <br />
              Crear <br /> Pedidos Clientes
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-clipboard-list fa-7x"></i>
          <br />
          <br />
          Crear <br /> Pedidos Clientes
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPedidoCliente" className="botonesMenu" color="success">
              <i class="fas fa-clipboard-list fa-7x"></i>
              <br />
              <br />
              Listado <br /> Pedidos Clientes
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-clipboard-list fa-7x"></i>
          <br />
          <br />
          Listado <br /> Pedidos Clientes
        </Button> }
          </Col> */}


          {/* </Row>
        <br />
        <Row> */}



          <Col md={4} align="center">
          {user.menu_devoluciones ?(
            <Button href="/ListadoDevoluciones" className="botonesMenu" color="success">
              <i class="fas fa-undo-alt fa-7x"></i>
              <br />
              <br />
              Devoluciones
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-undo-alt fa-7x"></i>
          <br />
          <br />
          Devoluciones
        </Button> }
          </Col>

          {/* <Col md={4} align="center">
              {user.menu_clientes ? (
                <Button
                  href="/ListadoCompradores"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Compradores
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Compradores
                </Button>
              )}
            </Col> */}


          {/* <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/VentaSalderos" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Venta Salderos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Venta Salderos
        </Button> }
          </Col> */}
        </Row>

        
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesCompras;
